import React, { useRef, useImperativeHandle } from "react";
import styled from "styled-components";
import Menu from "@components/ContentfulModuleNavigationMenu";
import { device } from "@helpers";
import Icon from "@components/Icon";

const StyleContainer = styled.div`
  max-width: 100%;
  margin: auto;
  display: ${props => props.visible};
  flex-direction: row;
  justify-content: flex-end;
  z-index: 10;
`;

const StyleIconsContainer = styled.div`
  font-size: 18px !important;
  align-self: center;
  margin-top: 12px;
  margin-right: 30px;
  cursor: pointer;
`;

const iconSizes = {
  iconMobile: "30",
  iconTablet: "40",
  iconLaptop: "60",
  iconDesktop: "60",
  iconDesktopLarge: "60",
};

class Navigation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: "flex",
    };
  }

  render() {
    const { onClick, onClose, data } = this.props;
    return (
      <>
        <StyleContainer visible={this.state.visible}>
          <StyleIconsContainer onClick={onClick}>
            <Icon iconName="menu" iconSizes={iconSizes} />
          </StyleIconsContainer>
        </StyleContainer>
        <Menu ref={el => (this.childMenu = el)} onClose={onClose} data={data} />
      </>
    );
  }

  toggleMenuOpen() {
    this.setState({ visible: "none" });
    this.childMenu.open({ marginTop: 0 });
  }

  toggleMenuClose() {
    this.setState({ visible: "flex" });
    this.childMenu.close();
  }
}

export default React.forwardRef((props, ref) => {
  const navRef = useRef();

  useImperativeHandle(ref, () => ({
    navOpen() {
      navRef.current.toggleMenuOpen();
    },
    navClose() {
      navRef.current.toggleMenuClose();
    },
  }));
  return <Navigation ref={navRef} {...props} />;
});
